import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { UrgencyBar } from './UrgencyBar';
import { PRICE, OLD_PRICE, PRODUCT_IMAGE, BONUSES } from '../data/content';
const ORDER_ITEMS = [{
  label: 'HYROX Definitivo 360 — Edición Coach (7 módulos)',
  value: OLD_PRICE
}, ...BONUSES.map(b => ({
  label: b.title,
  value: 'GRATIS'
}))];
export function FinalOffer() {
  return <section id="comprar" className="scroll-mt-4 px-5 py-12" data-id="element-58">
      <div className="mx-auto max-w-md" data-id="element-59">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-60">
          Empieza hoy a{' '}
          <span className="text-[#F5C518]" data-id="element-61">cubrirte las espaldas</span>
        </h2>

        <div className="mt-6 overflow-hidden rounded-2xl border border-[#F5C518]/40 bg-[#111]" data-id="element-62">
          <img src={PRODUCT_IMAGE} alt="HYROX Definitivo 360 — Edición Coach" className="w-full" data-id="element-63" />

          <div className="p-5" data-id="element-64">
            <UrgencyBar data-id="element-65" />

            {/* Order summary */}
            <div className="mt-5 rounded-xl border border-white/10 bg-black/40 p-4" data-id="element-66">
              <h3 className="mb-3 font-oswald text-sm font-700 uppercase tracking-wide text-white" data-id="element-67">
                Resumen del pedido
              </h3>
              <ul className="space-y-2.5" data-id="element-68">
                {ORDER_ITEMS.map((item, i) => <li key={i} className="flex items-start justify-between gap-3 text-[13px]" data-id="element-69">
                    <span className="flex items-start gap-2 text-neutral-300" data-id="element-70">
                      <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#F5C518]" data-id="element-71" />
                      {item.label}
                    </span>
                    <span className={`shrink-0 font-700 ${item.value === 'GRATIS' ? 'text-[#F5C518]' : 'text-neutral-400 line-through'}`} data-id="element-72">
                      {item.value}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-4 border-t border-white/10 pt-4" data-id="element-73">
                <div className="flex items-end justify-center gap-3" data-id="element-74">
                  <span className="font-oswald text-xl text-neutral-500 line-through" data-id="element-75">
                    {OLD_PRICE}
                  </span>
                  <span className="font-anton text-4xl text-[#F5C518]" data-id="element-76">
                    {PRICE}
                  </span>
                </div>
                <p className="mt-1 text-center text-[12px] text-neutral-400" data-id="element-77">
                  Pago único · Acceso inmediato · Los 5 bonos gratis hoy
                </p>
              </div>
            </div>

            <div className="mt-5" data-id="element-78">
              <BuyButton data-id="element-79" />
            </div>

            <div className="mt-4 flex items-center justify-center gap-2 text-[12px] text-neutral-400" data-id="element-80">
              <ShieldCheckIcon className="h-4 w-4 text-[#F5C518]" data-id="element-81" />
              Compra 100% segura · Entrega inmediata en tu email
            </div>
          </div>
        </div>
      </div>
    </section>;
}